"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var loadAdobeLaunch = function loadAdobeLaunch(_ref) {
  var _window$_satellite, _brandValues$property;
  var env = _ref.env,
    property = _ref.property;
  if (typeof window === 'undefined' || (_window$_satellite = window._satellite) !== null && _window$_satellite !== void 0 && _window$_satellite.property) return;
  var url = (_brandValues$property = _index.brandValues.propertyUrls[property]) === null || _brandValues$property === void 0 ? void 0 : _brandValues$property[env];
  if (!url) return;
  var tagExists = document.head.querySelector("script[src=\"".concat(url, "\"]"));
  if (tagExists) return;
  var script = document.createElement('script');
  script.src = url;
  script.defer = true;
  script.async = true;
  document.head.appendChild(script);
};
var _default = exports["default"] = loadAdobeLaunch;